module.exports = __webpack_public_path__ + "img/favicon.5d82208.png";